export const leaveTypes = {
  self: { value: 1, name: '主动离职' },
  dismiss: { value: 2, name: '辞退' },
  agreement: { value: 3, name: '协议解除' },
  other: { value: 4, name: '其他' },
};

export function findLeaveType(value) {
  for (const key in leaveTypes) {
    if (value === leaveTypes[key].value) return leaveTypes[key];
  }
  return {};
}
